// src/components/screens/NoFoundScreen.jsx
import React from 'react';
import { Zap, ArrowLeft } from 'lucide-react';

const NoFoundScreen = ({ title, setActiveScreen }) => (
    <div className="p-4">
      <div className="flex items-center mb-4">
        <ArrowLeft size={20} className="mr-2 cursor-pointer" onClick={() => setActiveScreen('home')} />
        <h2 className="text-xl font-bold text-gray-800">{title}</h2>
      </div>
      
      <div className="bg-white rounded-xl shadow-sm p-6 flex flex-col items-center justify-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <Zap className="text-green-600" />
        </div>
        <h3 className="text-lg font-semibold text-center mb-2">Tela em Desenvolvimento</h3>
        <p className="text-gray-500 text-center mb-4">Esta seção está sendo aprimorada para melhor atendê-lo.</p>
        <button 
          className="px-4 py-2 bg-green-600 text-white rounded-lg font-medium"
          onClick={() => setActiveScreen('home')}
        >
          Voltar para Início
        </button>
      </div>
    </div>
  );

export default NoFoundScreen;